import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  dialogProgress: {
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
    position: "absolute",
    marginTop: "50%",
    padding: "0.5rem 3rem",
    "@media(min-width:2560px) and (min-height: 1440px)": {
      marginTop: "40%",
    },
  },
  dialogSuccess: {
    background: "rgba(67, 110, 89, 0.8)",
    border: "2px solid #74D800",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
  },
  dialogPaper: {
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
  },
  positionComponent: {
    position: "absolute",
    top: 0,
    width: "100%",
  },
  dialogDisconnect: {
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
    position: "absolute",
    padding: "0rem 0.4rem",
    marginTop: "48%",
    "@media(min-width:2560px) and (min-height: 1440px)": {
      marginTop: "40%",
    },
  },
  overlayLoader: {
    background: "rgba(12, 13, 33, 0.6)",
    backdropFilter: "blur(8px)",
    width: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    height: "100vh",
    alignItems: "center",
    flexDirection: "column",
    zIndex: "9999",
  },
  scanningFooter: {
    position: "fixed",
    bottom: "40px",
    background: "rgba(19, 158, 100, 0.4)",
    borderRadius: "0.75rem",
    justifyContent: "center",
    display: "flex",
    textAlign: "center",
    padding: "1.5rem",
    backdropFilter: "blur(24px)",
    zIndex: "100",
  },
  dialogDelete: {
    background: "rgba(135, 94, 94, 0.8)",
    border: "2px solid #D65C5C",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
  },
  dialogDeleteProgress: {
    position: "absolute",
    marginTop: "50%",
    padding: "0rem 1rem",
    background: "rgba(67, 91, 110, 0.8)",
    border: "2px solid #56CCF2",
    backdropFilter: "blur(24px)",
    borderRadius: "24px",
    "@media(min-width:2560px) and (min-height: 1440px)": {
      marginTop: "40%",
    },
  },
});
